import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import {
	logout
} from '../../actions';
import UndoIcon from '@material-ui/icons/Undo';
import Button from '@material-ui/core/Button';
import {withStyles} from "@material-ui/core";
import Contact from "../components/form/contact";

const styles = theme => ({
	singInButton: {
		marginRight: theme.spacing.unit,
	},
	logout_button:{
		position:"absolute",
		right:15,
		top:13
	}
});

class header extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			contactOpen:false,
		}
	}

	handleClickLogout = () => {
		const {dispatch,history} = this.props;
		dispatch(logout());
		history.push('/');
	};

	openContactForm = () =>{
		this.setState({
			contactOpen:true
		})
	};


	closeContactForm = () =>{
		this.setState({
			contactOpen:false
		})
	};

	render () {
		const { classes, auth } = this.props;
		const name = auth.user.UserName;

		const Cont = () =>{
			return(
				this.state.contactOpen &&
				<Contact
					afterCloseFunc={this.closeContactForm}
				/>
			);
		};

		return ([
			<Cont key={0} />,
			<header key={1}>
				<h1>
					<img src="/images/common/logo.png" alt="ADEKAクリーンエイド株式会社 SDSダウンロード一覧" />
				</h1>
				<Button variant="contained" color="secondary" className={classes.logout_button} onClick={this.handleClickLogout}>
					<UndoIcon className={classes.singInButton} />
					ログアウト
				</Button>
			</header>,
			<div className="header_bottom" key={2}>
				{name} 様
				<a onClick={this.openContactForm}>
					ヘルプ ： 製品一覧にない場合のお問い合わせ
				</a>
			</div>
		]);
	}
}

header.propTypes = {
	history: PropTypes.object
};
function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(header);



// WEBPACK FOOTER //
// ./src/common/containers/header.js